import { useMemo } from 'react';
import useSWR from 'swr';
import LayerSwapApiClient from '../lib/apiClients/layerSwapApiClient';
import { resolveRoutesURLForSelectedToken } from '../helpers/routes';
/**
 * Fetches destination routes available for the deposit-address flow.
 * Mirrors the flags used by `useDepositAddressSources` so both pickers
 * see the same has_deposit_address / include_swaps_via_deposit_address set.
 */
export default function useDepositAddressDestinations({ enabled = true } = {}) {
    const apiClient = useMemo(() => new LayerSwapApiClient(), []);
    const url = useMemo(() => {
        if (!enabled)
            return null;
        return resolveRoutesURLForSelectedToken({
            direction: 'to',
            network: undefined,
            token: undefined,
            includes: { unmatched: false, unavailable: false, swaps: true },
            hasDepositAddress: true,
            useDepositAddressSwaps: true,
            useFrontendSwap: true,
        });
    }, [enabled]);
    const { data, isLoading } = useSWR(url, apiClient.fetcher, { dedupingInterval: 10000, keepPreviousData: true });
    return { data, isLoading };
}
